/* @ngInject */
export default function mediaQueryFactory(screenSize) {
  return screenSize;
}



// WEBPACK FOOTER //
// ./src/app/shared/media-query/media-query.factory.js